const filterBlock = () => {
    $(".filter-mob-toggle").on("click", function (event) {
        $(this).toggleClass("active");
        $(".filter-box").stop(true, true).slideToggle(500);
    });
};
export default filterBlock;



// WEBPACK FOOTER //
// ./assets/js/modules/filter.js